// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (orientation: landscape) {
  ion-content {
    --padding-start: calc(var(--sar, 0px) / 1.5);
    --padding-end: calc(var(--sal, 0px) / 1.5);
  }
}
ion-content ion-label {
  white-space: pre-wrap;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/idology-kba/idology-kba.component.scss"],"names":[],"mappings":"AACI;EADJ;IAEM,4CAAA;IACA,0CAAA;EACJ;AACF;AACI;EACE,qBAAA;AACN","sourcesContent":["ion-content {\n    @media (orientation: landscape) {\n      --padding-start: calc(var(--sar, 0px) / 1.5);\n      --padding-end: calc(var(--sal, 0px) / 1.5);\n    }\n\n    ion-label {\n      white-space: pre-wrap;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
